module.exports = __webpack_public_path__ + "static/media/dating-advice-com.47cc3c02.jpg";